import _ from "lodash";

/**
 * Sets the given text area to update its height automatically based on its content
 *
 * @param {HTMLInputElement} textArea
 * @param {number} [minHeight] The min height in pixels
 */
function autoHeightTextArea(textArea, minHeight = 80) {
	const updateHeight = _.throttle(() => {
			// Clear previous height
			textArea.style.height = '';

			// Get scroll height
			let scrollHeight = textArea.scrollHeight;

			// Add padding
			scrollHeight += 12;

			if (scrollHeight < minHeight) {
				scrollHeight = minHeight
			}

			// Set height
			textArea.style.height = scrollHeight + 'px';
		},
		8, {
			leading: true,
			trailing: false,
		}
	)

	textArea.addEventListener('change', updateHeight);
	textArea.addEventListener('keydown', updateHeight);


	// Initial render
	updateHeight();
}

export {autoHeightTextArea}
